<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-if="permissionList.includes(permission.add)" @click="getAddSettingPage()"><font-awesome-icon icon="plus"/> {{$t('setting_page.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getInfoSettingPage()" v-if="permissionList.includes(permission.info)">{{$t('setting_page.table_info')}}</b-button>
                            <b-button variant="success" size="lg" class="ml-1" @click="getEditSettingPage()" v-if="permissionList.includes(permission.edit)">{{$t('setting_page.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteSettingPage()" v-if="permissionList.includes(permission.delete)">{{$t('setting_page.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addSettingPage" :title="$t('setting_page.table_add')" @ok="addSettingPage" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')" size="lg">
                    <form id="addSettingPageForm" @submit.prevent="addSettingPage">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane custome-editor-tab" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name" class="custom-from-group">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_email.table_title')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                    <quill-editor v-model="ajaxAdd.content[lang.code]" class="custome-editor mt-3"></quill-editor>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editSettingPage" :title="$t('setting_page.table_edit')" @ok="editSettingPage" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')" size="lg">
                    <form id="editSettingPageForm" @submit.prevent="editSettingPage">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane custome-editor-tab" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_email.table_title')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'" v-model="ajaxEdit.title[lang.code]"></b-form-input>
                                    </b-form-group>
                                    <quill-editor v-model="ajaxEdit.content[lang.code]" class="custome-editor mt-3"></quill-editor>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="infoSettingPage" :title="ajaxInfo.title" size="lg" hide-footer="">
                    <p v-html="ajaxInfo.content"></p>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {settingPageAjaxTable,settingPageAdd,getSettingPageEdit,settingPageEdit,settingPageDelete,settingPageInfo} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',name:'',sort:'',status:''},
            ajaxAdd:{sort:10,languageList:[],content:[]},
            ajaxEdit:{languageList:[]},
            ajaxInfo:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'5E6752',
                edit:'B483BB',
                delete:'FA23A5',
                info:'DF2401'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '50'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width: '300'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width: '300'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = settingPageAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.name,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getInfoSettingPage(){
            if(this.permissionList.includes(this.permission.info)){
                var self = this;
                var result = settingPageInfo(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('infoSettingPage');
                        self.ajaxInfo = value.data;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },getAddSettingPage(){
            var self = this;
            var result = this.$general.getLanguageList();
            result.then(function(value){
                self.ajaxAdd.languageList = value.data;
                self.ajaxAdd.content = [];
                self.$bvModal.show('addSettingPage');
                for(var i = 0;i<self.ajaxAdd.languageList.length;i++){
                    self.ajaxAdd.content.push(self.ajaxAdd.languageList[i].code);
                }
            });
        },addSettingPage(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('addSettingPageForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                for(var i = 0;i<this.ajaxAdd.languageList.length;i++){
                    formData.append('content['+this.ajaxAdd.languageList[i].code+']', this.ajaxAdd.content[this.ajaxAdd.languageList[i].code]); 
                }
                var result = settingPageAdd(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                });      
            }      
        },getEditSettingPage(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSettingPageEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    if(value.valid){
                        self.preloader(false)
                        self.$bvModal.show('editSettingPage');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEdit.languageList = value.data.language_list;
                    }else{
                        self.preloader(true)
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editSettingPage(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('editSettingPageForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxEdit.id);
                for(var i = 0;i<self.ajaxEdit.languageList.length;i++){
                    formData.append('content['+self.ajaxEdit.languageList[i].code+']', this.ajaxEdit.content[self.ajaxEdit.languageList[i].code]); 
                }
                var result = settingPageEdit(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                })
            }
        },deleteSettingPage(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = settingPageDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
